import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  span {
    font-size: 20px;
    font-weight: 500;
    color: #555;
  }
`;
